module.exports = __webpack_public_path__ + "static/img/articleDetails-bg.891172e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/articleDetails-bg.png
// module id = UUop
// module chunks = 1